
// Scroll back button visibility
window.addEventListener('scroll', () => {
    const scrollBack = document.querySelector('.scroll-back');
    const shouldShowScrollBack = window.scrollY > 300;
  
    scrollBack.classList.toggle('active', shouldShowScrollBack);
});
